import { ColDef } from 'ag-grid-community';


/*
export class CustomDateFilterUtils {


  public static customDataFilterColDefinition(): ColDef {

    return {
      filter: 'agDateColumnFilter',
      floatingFilter: true,
      floatingFilterComponentParams: { suppressFilterButton: false },
      suppressMenu: true,
      menuTabs: [],
      filterParams: {
        suppressAndOrCondition: true,
        suppressFilterButton: false,
        filterOptions: [
          {
            displayKey: 'greaterThanEmpty',
            displayName: 'Greater Than',
            predicate: (filterValue: any, cellValue: any) => {
              if (!filterValue) return true;

              const filterTs = new Date(filterValue).getTime();
              if (isNaN(filterTs) || filterTs === 0) return true;

              const cellTs =
                typeof cellValue === 'number'
                  ? cellValue > 1e10 // timestamp già in ms
                    ? cellValue
                    : cellValue * 1000 // timestamp in sec → ms
                  : new Date(cellValue).getTime();

              console.log(
                '[greaterThan]',
                new Date(cellTs).toLocaleString(),
                '>',
                new Date(filterTs).toLocaleString(),
                '→',
                cellTs > filterTs
              );
              return cellTs > filterTs;
            },
          },
          {
            displayKey: 'lessThanEmpty',
            displayName: 'Less Than',
            predicate: (filterValue: any, cellValue: any) => {
              if (!filterValue) return true;

              const filterTs = new Date(filterValue).getTime();
              if (isNaN(filterTs) || filterTs === 0) return true;

              const cellTs =
                typeof cellValue === 'number'
                  ? cellValue > 1e10
                    ? cellValue
                    : cellValue * 1000
                  : new Date(cellValue).getTime();

              console.log(
                '[lessThan]',
                new Date(cellTs).toLocaleString(),
                '<',
                new Date(filterTs).toLocaleString(),
                '→',
                cellTs < filterTs
              );
              return cellTs < filterTs;
            },
          },
        ],
      },
    } as ColDef;
  }
}
*/

export class CustomDateFilterUtils {
  private static resolveCellTs(cellValue: any): number | null {
    if (typeof cellValue === 'number') {
      return cellValue > 1e10 ? cellValue : cellValue * 1000;
    }
    if (cellValue instanceof Date) {
      return isNaN(cellValue.getTime()) ? null : cellValue.getTime();
    }
    if (typeof cellValue === 'string' && cellValue.includes('/')) {
      const parts = cellValue.split('/');
      if (parts.length !== 3) return null;
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      const date = new Date(year, month, day);
      return isNaN(date.getTime()) ? null : date.getTime();
    }
    const ts = new Date(cellValue).getTime();
    return isNaN(ts) ? null : ts;
  }

  public static customDataFilterColDefinition(): ColDef {
    return {
      filter: 'agDateColumnFilter',
      floatingFilter: true,
      floatingFilterComponentParams: { suppressFilterButton: false },
      suppressMenu: true,
      menuTabs: [],
      filterParams: {
        suppressAndOrCondition: true,
        suppressFilterButton: false,

        dateParser: (value: string): Date | null => {
          if (!value) return null;
          const parts = value.split('/');
          if (parts.length !== 3) return null;
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10) - 1;
          const year = parseInt(parts[2], 10);
          const date = new Date(year, month, day);
          return isNaN(date.getTime()) ? null : date;
        },

        filterOptions: [
          {
            displayKey: 'greaterThanEmpty',
            displayName: 'Greater Than',
            predicate: (filterValue: any, cellValue: any): boolean => {
              if (!filterValue) return true;

              const filterTs =
                filterValue instanceof Date
                  ? filterValue.getTime()
                  : new Date(filterValue).getTime();

              if (isNaN(filterTs)) return true;

              const cellTs = CustomDateFilterUtils.resolveCellTs(cellValue);
              if (cellTs === null) return false;

              // console.log(
              //   '[greaterThan]',
              //   new Date(cellTs).toLocaleString(),
              //   '>',
              //   new Date(filterTs).toLocaleString(),
              //   '→',
              //   cellTs > filterTs
              // );

              return cellTs > filterTs;
            },
          },
          {
            displayKey: 'lessThanEmpty',
            displayName: 'Less Than',
            predicate: (filterValue: any, cellValue: any): boolean => {
              if (!filterValue) return true;

              const filterTs =
                filterValue instanceof Date
                  ? filterValue.getTime()
                  : new Date(filterValue).getTime();

              if (isNaN(filterTs)) return true;

              const cellTs = CustomDateFilterUtils.resolveCellTs(cellValue);
              if (cellTs === null) return false;

              // console.log(
              //   '[lessThan]',
              //   new Date(cellTs).toLocaleString(),
              //   '<',
              //   new Date(filterTs).toLocaleString(),
              //   '→',
              //   cellTs < filterTs
              // );

              return cellTs < filterTs;
            },
          },
        ],
      },
    } as ColDef;
  }
}
